/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import React from 'react';
import { handleKeyDownSubmission } from '../../../utils/cs-helpers';

const AppointmentDateCard = ({
  date,
  isSelected,
  isDisabled,
  setSelectedAppointmentDate,
  month,
  dayNumber,
  dayOfWeek,
  dateHasConfigs
}) => {
  const handleAppointmentDateSelection = () => {
    if (dateHasConfigs && !isDisabled) {
      setSelectedAppointmentDate(date);
    }
  };

  return (
    <div
      className={`appointment-date-wrapper ${dateHasConfigs && !isDisabled ? '' : 'disabled'} ${
        isSelected ? 'selected' : ''
      }`}
      role="button"
      tabIndex="0"
      aria-label={`${month} ${dayNumber}, ${dayOfWeek}`}
      aria-hidden="false"
      onClick={handleAppointmentDateSelection}
      onKeyDown={e => handleKeyDownSubmission(e, handleAppointmentDateSelection)}
      disabled={dateHasConfigs && !isDisabled ? false : true}
    >
      <div className="month-wrapper">
        <p className="month">{month}</p>
      </div>
      <div className="day-wrapper">
        <p className="day-number">{dayNumber}</p>
        <p className="day-of-week">{dayOfWeek}</p>
      </div>
    </div>
  );
};

export default React.memo(AppointmentDateCard);
